import { omit } from "lodash";
import { TableDataType } from "../types";

const csvInvestorRankingHeaders = {
  investorName: "Investor Name",
  investorUrl: "Website",
  hqCity: "HQ City",
  hqCountry: "HQ Country",
  dealCount: "Deal Count",
  focus: "Focus",
  fundLaunchYear: "Fund Launch Year",
  fundType: "Fund Type",
  unicornCount: "Unicorn Count",
};

const csvStartupRankingHeaders = {
  company: "Company Name",
  website: "Website",
  hqCity: "HQ City",
  hqCountry: "HQ Country",
  founded: "Year Founded",
  stage: "Stage",
  lastRoundSize: "Last Round Size",
  totalFunding: "Total Funding",
};

export const downloadCSV = (data: TableDataType[]) => {
  const csvRows: string[][] = [];

  const csvHeaders = Object.keys(data[0]).includes("company")
    ? csvStartupRankingHeaders
    : csvInvestorRankingHeaders;

  data
    .map((ranking) => omit(ranking, ["latestFundSize", "investorLogo"]))
    .forEach((ranking) => {
      const row: string[] = [];
      for (const key of Object.keys(csvHeaders)) {
        if (key === "hqCity" || key === "hqCountry") {
          const val = String(
            ranking["location"]![key === "hqCity" ? 0 : 1]
          ).replace(/"/g, "'");
          row.push(`"${val}"`);
        } else {
          const val = String(ranking[key] || "").replace(/"/g, "'");
          row.push(`"${val}"`);
        }
      }

      csvRows.push(row);
    });

  const csvContent = [Object.values(csvHeaders), ...csvRows].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${document.title.replace(/\s/g, "_")}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
